import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Trash2 } from 'lucide-react';
import { formatCurrency, formatDate } from '../../utils/poFormatters.jsx';

export const ExtensionsListDialog = ({ open, onOpenChange, po, extensions, onDelete }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg" data-testid="extensions-list-dialog">
      <DialogHeader>
        <DialogTitle>Extensions for {po?.po_number}</DialogTitle>
        <DialogDescription>
          Base amount: {formatCurrency(po?.total_amount, po?.currency)}. Each
          extension below tops up the consolidated total; invoicing always references the parent PO number.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-3 max-h-80 overflow-y-auto">
        {extensions.length === 0 ? (
          <p className="text-sm text-muted-foreground" data-testid="no-extensions-message">No extensions yet.</p>
        ) : (
          extensions.map(ext => (
            <div key={ext.id} className="flex items-center justify-between border rounded-lg p-3" data-testid={`extension-row-${ext.id}`}>
              <div>
                <div className="font-medium text-sm">{ext.po_number}</div>
                <div className="text-xs text-muted-foreground">
                  Issued {formatDate(ext.issue_date)}
                  {ext.sow_reference ? ` · SOW: ${ext.sow_reference}` : ''}
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="font-medium text-sm">{formatCurrency(ext.total_amount, po?.currency)}</span>
                <Button variant="ghost" size="icon" onClick={() => onDelete(ext.id)} className="text-destructive hover:text-destructive" data-testid={`delete-extension-${ext.id}`}>
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            </div>
          ))
        )}
      </div>
    </DialogContent>
  </Dialog>
);

export default ExtensionsListDialog;
